module.exports = __webpack_public_path__ + "img/azure-solutions-architect-expert.32756adc.png";